import React from 'react';

export function RenderDoubleButton({ children }) {
  return (
    <div className={'double-btns'}>
      {children}
    </div>
  );
}